(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class StickyAnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.announcementBar = document.getElementById('StickyAnnouncementBar-{{ section.id }}');
      if (!this.announcementBar) return;

      this.header = document.querySelector('.section-header');
      
      // 初期設定
      this.updatePosition();
      
      // リサイズ時に位置を更新
      window.addEventListener('resize', this.updatePosition.bind(this));
      
      // アナウンスバーのコンテンツ変更を監視
      this.announcementObserver = new MutationObserver(() => {
        setTimeout(() => this.updatePosition(), 100);
      });
      
      this.announcementObserver.observe(this.announcementBar, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style']
      });
      
      // ヘッダーの高さ変更を監視
      if (this.header) {
        this.headerObserver = new MutationObserver(() => {
          setTimeout(() => this.updatePosition(), 100);
        });
        
        this.headerObserver.observe(this.header, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class', 'style']
        });
        
        // ヘッダーの高さが設定されるまで待機
        this.waitForHeaderHeight();
      }
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.updatePosition.bind(this));
      if (this.announcementObserver) {
        this.announcementObserver.disconnect();
      }
      if (this.headerObserver) {
        this.headerObserver.disconnect();
      }
      if (this.headerHeightCheckInterval) {
        clearInterval(this.headerHeightCheckInterval);
      }
    }

    waitForHeaderHeight() {
      // ヘッダーの高さが設定されるまで待機（最大5秒）
      let attempts = 0;
      this.headerHeightCheckInterval = setInterval(() => {
        const headerHeight = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
        if (headerHeight && headerHeight !== '0px' && headerHeight !== '') {
          this.updatePosition();
          clearInterval(this.headerHeightCheckInterval);
        }
        attempts++;
        if (attempts > 50) {
          clearInterval(this.headerHeightCheckInterval);
        }
      }, 100);
    }

    updatePosition() {
      if (!this.announcementBar) return;
      
      // ヘッダーの高さを取得
      let headerHeight = 0;
      if (this.header) {
        headerHeight = this.header.offsetHeight;
        // CSS変数も更新
        document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
      } else {
        // CSS変数から取得を試みる
        const headerHeightValue = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
        if (headerHeightValue) {
          headerHeight = parseFloat(headerHeightValue);
        }
      }
      
      // アナウンスバーの高さを設定
      const announcementHeight = this.announcementBar.offsetHeight;
      document.documentElement.style.setProperty('--sticky-announcement-bar-height', `${announcementHeight}px`);
      
      // アナウンスバーの位置を更新（CSS変数で自動的に適用される）
      // top: var(--header-height) がCSSで設定されているため、自動的に適用される
    }
  }

  customElements.define('sticky-announcement-bar', StickyAnnouncementBar);

  } catch(e) { console.error(e); }
})();
})();
